import styled from 'styled-components';

import { spacing } from 'ui/theme';

import { useFormContext } from '../../contexts/FormContext';
import { FormGridAreas } from '../../types';
import { SubmitButton } from './SubmitButton';
import { IdentifierInput } from './IdentifierInput';
import { LookupTypeRadioList } from './LookupTypeRadioList';

const Form = styled.form`
  display: grid;
  grid-template-columns: minmax(${spacing.x32}, 1fr) min-content 1fr;
  grid-template-areas:
    '${FormGridAreas.lookupTypeRadioList} ${FormGridAreas.lookupTypeRadioList}'
    '${FormGridAreas.identifierInput} ${FormGridAreas.submitButton}';
  grid-gap: ${spacing.base} ${spacing.half};
  margin-bottom: ${spacing.x8};
`;

export const LookupForm = () => {
  const { canSubmit, submit, availableLookupTypes } = useFormContext();
  const canChooseLookupType = availableLookupTypes.length > 1;
  return (
    <Form onSubmit={canSubmit ? submit : undefined}>
      {canChooseLookupType && <LookupTypeRadioList />}
      <IdentifierInput />
      <SubmitButton />
    </Form>
  );
};
